import { render, staticRenderFns } from "./a-order-gift.vue?vue&type=template&id=8158b832&scoped=true&"
import script from "./a-order-gift.vue?vue&type=script&lang=js&"
export * from "./a-order-gift.vue?vue&type=script&lang=js&"
import style0 from "./a-order-gift.vue?vue&type=style&index=0&id=8158b832&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8158b832",
  null
  
)

export default component.exports